import { defaultTheme, lightTheme } from '@dsx/react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles';

const rootEl = document.getElementById('root');

if (!rootEl) {
	throw new Error('could not find root element');
}

const root = createRoot(rootEl);

document.body.classList.add(defaultTheme, lightTheme);

root.render(<App />);
